import React from "react";
import Hero from "../components/Hero";
import imageBig from "../assets/images/team-header-big.jpg";
import imageSmall from "../assets/images/team-header-small.jpg";
import { Flex, Box } from "../components/Layout";
import { TeamCard, TeamDescription } from "../components/Cards";
import feather from "../utils/feather.js";
import SEO from "../components/SEO";

export default ({ data }) => {
  const { edges: team } = data.allTeamJson;
  const myTitle = 'Experts in Data Networks, Structured Cabling, and Fiber Optics | PCS'
  const myDesc = 'PCS team has decades of low voltage wiring and data network design between them. PCS is your one stop shop for all thing data.'
  return (
    <div> 
      <SEO title={myTitle}
        description={myDesc}
      />
      <Hero imageBig={imageBig} imageSmall={imageSmall}>
        <Box color="white" p={[3, 3, 3]} align="left">
          <h1>Team</h1>
        </Box>
      </Hero>
      <Box color="white" p={[2, 2, 2]} align="left">
        <Flex wrap={["wrap", "wrap", "wrap"]} justify="space-between">
          {team.map(({ node: item }) => {
            return (
              <Box key={item.id} color="white" width={[1, 1, `20%`]}>
                <TeamCard>
                  <div>
                    <img
                      src={item.avatar.children[0].responsiveResolution.src}
                      srcSet={
                        item.avatar.children[0].responsiveResolution.srcSet}
                      alt={`Picture of ${item.name}`}
                    />
                  </div>
                  <TeamDescription>
                    <h2>{item.name}</h2>
                    <span>
                      <em>{item.position}</em>
                    </span>
                    <p>{item.description}</p>
                    <ul>
                      <li>
                        <a href={`mailto:${item.email}`}>
                          {feather("mail", ["20", "20"])}
                        </a>
                      </li>
                    </ul>
                  </TeamDescription>
                </TeamCard>
              </Box>
            );
          })}
        </Flex>
      </Box>
    </div>
  );
};

export const pageQuery = graphql`
  query TeamQuery {
    allTeamJson {
      edges {
        node {
          id
          name
          position
          description
          email
          linkedin
          avatar {
            children {
              ... on ImageSharp {
                responsiveResolution(width: 300) {
                  src
                  srcSet
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/team.js